import { useState, useEffect } from 'react';
import api from '../../../services/api';
import './AdminSlider.css';

const AdminEmbeds = () => {
  const [embeds, setEmbeds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingEmbed, setEditingEmbed] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [embedWidth, setEmbedWidth] = useState(100);
  const [embedHeight, setEmbedHeight] = useState(450);
  const [newEmbed, setNewEmbed] = useState({ title: '', embedCode: '', description: '', showOnHomepage: true });

  useEffect(() => { fetchEmbeds(); fetchEmbedSettings(); }, []);

  const fetchEmbeds = async () => {
    try { setLoading(true); const res = await api.get('/api/embeds?all=true'); setEmbeds(res.data); }
    catch { setError('Yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const fetchEmbedSettings = async () => {
    try {
      const res = await api.get('/api/settings');
      if (res.data?.embedSettings) {
        setEmbedWidth(res.data.embedSettings.width || 100);
        setEmbedHeight(res.data.embedSettings.height || 450);
      }
    } catch {}
  };

  const saveEmbedSettings = async (w, h) => {
    try {
      await api.put('/api/settings', { embedSettings: { width: w, height: h } });
      setSuccess('Ayarlar kaydedildi.');
      setTimeout(() => setSuccess(''), 2000);
    } catch { setError('Ayarlar kaydedilemedi.'); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!newEmbed.title || !newEmbed.embedCode) { setError('Başlık ve embed kodu zorunlu.'); return; }
    try {
      await api.post('/api/embeds', newEmbed);
      setSuccess('Embed eklendi.');
      setShowAddForm(false);
      setNewEmbed({ title: '', embedCode: '', description: '', showOnHomepage: true });
      fetchEmbeds();
    } catch (err) { setError(err.response?.data?.message || 'Eklenemedi.'); }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await api.put(`/api/embeds/${editingEmbed._id}`, editingEmbed);
      setSuccess('Güncellendi.');
      setEditingEmbed(null);
      fetchEmbeds();
    } catch { setError('Güncellenemedi.'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Silmek istediğinizden emin misiniz?')) return;
    try { await api.delete(`/api/embeds/${id}`); setSuccess('Silindi.'); fetchEmbeds(); }
    catch { setError('Silinemedi.'); }
  };

  const handleToggleActive = async (embed) => {
    try {
      await api.put(`/api/embeds/${embed._id}`, { isActive: !embed.isActive });
      fetchEmbeds();
    } catch { setError('Güncellenemedi.'); }
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Embed / iframe ({embeds.length})</h3>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className="admin-slider-add-btn" onClick={() => { setShowAddForm(!showAddForm); setEditingEmbed(null); }}>+ Yeni Embed</button>
            <button className="admin-slider-add-btn" style={{ backgroundColor: '#4b5563' }} onClick={() => setShowSettings(!showSettings)}>Ayarlar</button>
          </div>
        </div>

        {/* Ayarlar */}
        {showSettings && (
          <div style={{ padding: '1rem 1.5rem', backgroundColor: '#374151', borderBottom: '1px solid #4b5563' }}>
            <h4 style={{ fontSize: '0.9rem', fontWeight: '600', color: '#f3f4f6', margin: '0 0 1rem 0' }}>Görüntüleme Ayarları</h4>
            <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'center' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8rem', color: '#d1d5db' }}>
                Genişlik: {embedWidth}%
                <input type="range" min="30" max="100" value={embedWidth} onChange={(e) => setEmbedWidth(parseInt(e.target.value))} onMouseUp={(e) => saveEmbedSettings(parseInt(e.target.value), embedHeight)} style={{ width: '120px', accentColor: '#2563eb' }} />
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8rem', color: '#d1d5db' }}>
                Yükseklik: {embedHeight}px
                <input type="range" min="150" max="800" value={embedHeight} onChange={(e) => setEmbedHeight(parseInt(e.target.value))} onMouseUp={(e) => saveEmbedSettings(embedWidth, parseInt(e.target.value))} style={{ width: '120px', accentColor: '#2563eb' }} />
              </label>
              <button onClick={() => saveEmbedSettings(embedWidth, embedHeight)} style={{ padding: '0.3rem 0.75rem', backgroundColor: '#059669', color: '#fff', border: 'none', borderRadius: '0.25rem', fontSize: '0.75rem', cursor: 'pointer' }}>Kaydet</button>
            </div>
          </div>
        )}

        {/* Ekleme Formu */}
        {showAddForm && (
          <form className="admin-slider-form" onSubmit={handleAdd}>
            <h4>Yeni Embed Ekle</h4>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={newEmbed.title} onChange={(e) => setNewEmbed({ ...newEmbed, title: e.target.value })} required />
            </div>
            <div className="admin-slider-form-group">
              <label>Embed / iframe Kodu</label>
              <textarea value={newEmbed.embedCode} onChange={(e) => setNewEmbed({ ...newEmbed, embedCode: e.target.value })} rows="4" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.8rem', fontFamily: 'monospace', resize: 'vertical' }} placeholder='<iframe src="..." width="100%" height="400"></iframe>' required />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama (opsiyonel)</label>
              <input type="text" value={newEmbed.description} onChange={(e) => setNewEmbed({ ...newEmbed, description: e.target.value })} />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', marginBottom: '1rem' }}>
              <input type="checkbox" checked={newEmbed.showOnHomepage} onChange={(e) => setNewEmbed({ ...newEmbed, showOnHomepage: e.target.checked })} style={{ accentColor: '#2563eb' }} />
              <span style={{ fontSize: '0.85rem', color: '#d1d5db' }}>Ana sayfada göster</span>
            </label>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Ekle</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setShowAddForm(false)}>İptal</button>
            </div>
          </form>
        )}

        {/* Düzenleme Formu */}
        {editingEmbed && (
          <form className="admin-slider-form" onSubmit={handleUpdate}>
            <h4>Düzenle: {editingEmbed.title}</h4>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={editingEmbed.title} onChange={(e) => setEditingEmbed({ ...editingEmbed, title: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Embed / iframe Kodu</label>
              <textarea value={editingEmbed.embedCode} onChange={(e) => setEditingEmbed({ ...editingEmbed, embedCode: e.target.value })} rows="4" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.8rem', fontFamily: 'monospace', resize: 'vertical' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama</label>
              <input type="text" value={editingEmbed.description || ''} onChange={(e) => setEditingEmbed({ ...editingEmbed, description: e.target.value })} />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', marginBottom: '1rem' }}>
              <input type="checkbox" checked={editingEmbed.showOnHomepage} onChange={(e) => setEditingEmbed({ ...editingEmbed, showOnHomepage: e.target.checked })} style={{ accentColor: '#2563eb' }} />
              <span style={{ fontSize: '0.85rem', color: '#d1d5db' }}>Ana sayfada göster</span>
            </label>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Kaydet</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setEditingEmbed(null)}>İptal</button>
            </div>
          </form>
        )}

        {/* Liste - 3'lü Grid */}
        {embeds.length > 0 ? (
          <div style={{ padding: '1rem 1.5rem', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.75rem' }}>
            {embeds.map((embed) => (
              <div key={embed._id} style={{ backgroundColor: '#374151', borderRadius: '0.5rem', overflow: 'hidden', borderLeft: embed.isActive ? '3px solid #10b981' : '3px solid #6b7280' }}>
                {/* Önizleme Kutusu */}
                <div style={{ height: '100px', overflow: 'hidden', backgroundColor: '#1f2937', position: 'relative' }}>
                  <div dangerouslySetInnerHTML={{ __html: embed.embedCode }} style={{ transform: 'scale(0.12)', transformOrigin: 'top left', width: '833%', height: '833px', pointerEvents: 'none' }} />
                </div>
                {/* Bilgi */}
                <div style={{ padding: '0.6rem' }}>
                  <strong style={{ color: '#f3f4f6', fontSize: '0.8rem', display: 'block', marginBottom: '0.2rem' }}>{embed.title}</strong>
                  <div style={{ display: 'flex', gap: '0.3rem', marginBottom: '0.4rem' }}>
                    {embed.showOnHomepage && <span style={{ fontSize: '0.6rem', padding: '0.1rem 0.3rem', borderRadius: '9999px', backgroundColor: 'rgba(59,130,246,0.15)', color: '#60a5fa' }}>Ana Sayfa</span>}
                    <span style={{ fontSize: '0.6rem', padding: '0.1rem 0.3rem', borderRadius: '9999px', backgroundColor: embed.isActive ? 'rgba(16,185,129,0.15)' : 'rgba(107,114,128,0.15)', color: embed.isActive ? '#34d399' : '#9ca3af' }}>{embed.isActive ? 'Aktif' : 'Pasif'}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '0.3rem', flexWrap: 'wrap' }}>
                    <button className="admin-slider-btn-edit" style={{ fontSize: '0.65rem', padding: '0.2rem 0.4rem' }} onClick={() => handleToggleActive(embed)}>{embed.isActive ? 'Pasif' : 'Aktif'}</button>
                    <button className="admin-slider-btn-edit" style={{ fontSize: '0.65rem', padding: '0.2rem 0.4rem' }} onClick={() => { setEditingEmbed({ ...embed }); setShowAddForm(false); }}>Düzenle</button>
                    <button className="admin-slider-btn-delete" style={{ fontSize: '0.65rem', padding: '0.2rem 0.4rem' }} onClick={() => handleDelete(embed._id)}>Sil</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : <div className="admin-slider-empty">Henüz embed eklenmemiş.</div>}
      </div>
    </div>
  );
};

export default AdminEmbeds;
